require("./event_ggm3_whenbroadcasted.js");
require("./event_ggm3_broadcast.js");
require("./event_ggm3_broadcast_and_wait.js");
require("./event_ggm3_frame_broadcast.js");
require("./event_ggm3_broadcast_menu.js");